(function () {
  "use strict";

  function initAccessoryBlock() {
    var block = document.querySelector("[data-pdp-acc-block]");
    if (!block || block.__mgsAccInitialized) return;
    block.__mgsAccInitialized = true;

    function slice(nl) {
      return Array.prototype.slice.call(nl);
    }

    function money(cents) {
      var n = (parseInt(cents, 10) || 0) / 100;
      return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function cleanString(str) {
      return (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    }

    var cards = slice(block.querySelectorAll("[data-pdp-acc-addable]"));
    var totalEl = block.querySelector("[data-pdp-acc-total]");
    var labelEl = block.querySelector("[data-pdp-acc-total-label]");
    var valueEl = block.querySelector("[data-pdp-acc-total-value]");
    var mainPrices = {};

    try {
      var mp = block.querySelector("[data-pdp-acc-main-prices]");
      if (mp) mainPrices = JSON.parse(mp.textContent || "{}");
    } catch (e) {}

    var firstMainPrice = 0;
    for (var k in mainPrices) {
      if (mainPrices.hasOwnProperty(k)) {
        firstMainPrice = mainPrices[k];
        break;
      }
    }

    var variantSelection = document.querySelector("[data-variant-selection]");
    var form = block.closest("form[data-product-form]") || document.querySelector("form[data-product-form]") || document.querySelector('form[action*="/cart/add"]');
    var qtyInput = document.querySelector(".quantity-selector__input, [name='quantity']");

    function getDeliveryRoot() {
      return document.querySelector("[data-mgs-delivery-root]");
    }

    function getDeliveryMap() {
      var deliveryRoot = getDeliveryRoot();
      if (!deliveryRoot) return {};
      try {
        var dm = deliveryRoot.querySelector("[data-mgs-delivery-map]");
        return dm ? JSON.parse(dm.textContent || "{}") : {};
      } catch (e) {
        return {};
      }
    }

    function mainVariantId() {
      var id = variantSelection ? variantSelection.getAttribute("variant") : null;
      if ((!id || id === "not-selected") && form) {
        var el = form.querySelector('[name="id"]');
        if (el) id = el.value;
      }
      return id;
    }

    function liftDeliveryValue() {
      var deliveryRoot = getDeliveryRoot();
      if (!deliveryRoot) return null;
      var map = getDeliveryMap();
      var id = mainVariantId();
      return id != null && map[id] != null ? map[id] : null;
    }

    function mainUnitPrice() {
      var id = mainVariantId();
      return id != null && mainPrices[id] != null ? mainPrices[id] : firstMainPrice;
    }

    function mainQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return q && q > 0 ? q : 1;
    }

    function isChecked(card) {
      var cb = card.querySelector("[data-pdp-acc-checkbox]");
      return !!(cb && cb.checked);
    }

    function selectedOption(card) {
      var s = card.querySelector("[data-pdp-acc-select]");
      return s && s.options[s.selectedIndex] ? s.options[s.selectedIndex] : null;
    }

    function rowPrice(card) {
      var opt = selectedOption(card);
      return opt ? parseInt(opt.getAttribute("data-price"), 10) || 0 : parseInt(card.getAttribute("data-default-price"), 10) || 0;
    }

    // Parse main product options map
        var mainVariantsMap = {};
        try {
        var mvm = block.querySelector("[data-pdp-acc-main-variants]");
        if (mvm) mainVariantsMap = JSON.parse(mvm.textContent || "{}");
        } catch (e) {}

        function applyInheritance(card) {
        var sel = card.querySelector("[data-pdp-acc-select]");
        if (!sel) return;

        // 1. Gather all active options from the main product
        var id = mainVariantId();
        var mainOptions = [];
        if (id && mainVariantsMap[id]) {
            mainOptions = mainVariantsMap[id].map(function (v) {
            return String(v).trim().toLowerCase();
            });
        }

        // Include delivery override if available
        var liftVal = liftDeliveryValue();
        if (liftVal) {
            mainOptions.push(String(liftVal).trim().toLowerCase());
        }

        if (mainOptions.length === 0) return;

        // 2. Score every upsell option against main product options
        var bestIdx = -1;
        var maxScore = -1;

        for (var i = 0; i < sel.options.length; i++) {
            var opt = sel.options[i];
            var rawText = (
            opt.getAttribute("data-options") ||
            opt.getAttribute("data-delivery") ||
            opt.text ||
            ""
            ).toLowerCase();

            // Split attributes like "110v / Warehouse Pickup" into individual tokens
            var tokens = rawText
            .split(/[\/,\-—]/)
            .map(function (t) {
                return t.trim();
            })
            .filter(Boolean);

            var score = 0;
            for (var m = 0; m < mainOptions.length; m++) {
            var target = mainOptions[m];
            for (var t = 0; t < tokens.length; t++) {
                if (tokens[t] === target || tokens[t].indexOf(target) > -1 || target.indexOf(tokens[t]) > -1) {
                score++;
                break;
                }
            }
            }

            if (score > maxScore) {
            maxScore = score;
            bestIdx = i;
            }
        }

        // 3. Switch to the option that matches the most attributes
        if (bestIdx > -1 && sel.selectedIndex !== bestIdx) {
            sel.selectedIndex = bestIdx;
            updateRowFromSelect(card);
        }
        }

        function syncPickupFlag(card) {
        var kind = card.getAttribute("data-pdp-acc-kind"),
            isPickup = false;

        if (kind === "freight") {
            isPickup = !card.hidden;
        } else if (kind === "delivery") {
            var opt = selectedOption(card);
            var rawVal = opt
            ? (opt.getAttribute("data-options") || opt.getAttribute("data-delivery") || opt.text || "").toLowerCase()
            : "";
            isPickup = rawVal.indexOf(PICKUP.toLowerCase()) > -1;
        }

        if (isPickup) {
            card.setAttribute("data-pdp-acc-pickup", "1");
        } else {
            card.removeAttribute("data-pdp-acc-pickup");
        }
        }

    function updateRowFromSelect(card) {
      var opt = selectedOption(card);
      var priceEl = card.querySelector("[data-pdp-acc-price]");
      var compEl = card.querySelector("[data-pdp-acc-compare]");
      if (priceEl && opt) priceEl.textContent = money(opt.getAttribute("data-price"));
      if (compEl && opt) {
        var c = parseInt(opt.getAttribute("data-compare"), 10) || 0;
        var p = parseInt(opt.getAttribute("data-price"), 10) || 0;
        compEl.textContent = c > p ? money(c) : "";
      }
      var cb = card.querySelector("[data-pdp-acc-checkbox]");
      if (cb && opt) cb.setAttribute("data-variant-id", opt.value);
    }

    function recompute() {
      if (!totalEl) return;
      var n = 0, accSum = 0;
      cards.forEach(function (card) {
        if (isChecked(card)) {
          n += 1;
          accSum += rowPrice(card);
        }
      });
      if (n === 0) {
        totalEl.setAttribute("hidden", "");
        return;
      }
      totalEl.removeAttribute("hidden");
      if (labelEl) labelEl.textContent = "Total with " + n + (n === 1 ? " add-on:" : " add-ons:");
      if (valueEl) valueEl.textContent = money(mainUnitPrice() * mainQty() + accSum);
    }

    function onLiftChange() {
      cards.forEach(function (card) {
        if (card.getAttribute("data-pdp-acc-kind") === "delivery") {
          applyInheritance(card);
        }
      });
      recompute();
    }

    function wireCard(card) {
      var cb = card.querySelector("[data-pdp-acc-checkbox]");
      if (cb) {
        cb.addEventListener("change", function () {
          card.classList.toggle("is-selected", cb.checked);
          recompute();
        });
      }
      var sel = card.querySelector("[data-pdp-acc-select]");
      if (sel) {
        sel.addEventListener("change", function () {
          card.setAttribute("data-pdp-acc-overridden", "1");
          updateRowFromSelect(card);
          recompute();
        });
      }
      card.addEventListener("click", function (e) {
        if (!e.target.closest("a, select, input, label, option, button, [data-pdp-acc-modal]")) {
          if (cb) {
            cb.checked = !cb.checked;
            cb.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
    }

    cards.forEach(wireCard);



    // --- Modal / Popup Logic for "Learn More" ---
    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute("hidden", "");
      document.body.style.overflow = "";
    }

    function openModal(modal) {
      if (!modal) return;
      modal.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
      var closeBtn = modal.querySelector(".pdp-acc-modal__close, [data-pdp-acc-modal-close]");
      if (closeBtn) {
        try { closeBtn.focus(); } catch (e) {}
      }
    }

    // Attach modals to body and wire close triggers
    cards.forEach(function (card) {
      var modal = card.querySelector("[data-pdp-acc-modal]");
      if (modal) {
        document.body.appendChild(modal);
        card.__accModal = modal;
        modal.addEventListener("click", function (e) {
          if (e.target.closest("[data-pdp-acc-modal-close]") || e.target === modal) {
            e.preventDefault();
            closeModal(modal);
          }
        });
      }
    });

    // Handle "Learn More" button clicks
    block.addEventListener("click", function (e) {
      var learnBtn = e.target.closest("[data-pdp-acc-learn]");
      if (learnBtn) {
        e.preventDefault();
        var card = learnBtn.closest("[data-pdp-acc-card]");
        if (card && card.__accModal) {
          openModal(card.__accModal);
        }
      }
    });

    // Close on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        var openDialog = document.querySelector("[data-pdp-acc-modal]:not([hidden])");
        if (openDialog) closeModal(openDialog);
      }
    });
    // ---------------------------------------------

    

    // Initial check on load
    onLiftChange();

    // Empire Theme Event Listeners
    if (variantSelection && window.MutationObserver) {
      new MutationObserver(onLiftChange).observe(variantSelection, { attributes: true, attributeFilter: ["variant"] });
    }
    document.addEventListener("variant-change", onLiftChange);
    document.addEventListener("variant:changed", onLiftChange);

    if (form) {
      form.addEventListener("change", function (e) {
        if (e.target && (e.target.name === "id" || e.target.matches("[data-variant-option-value]"))) {
          setTimeout(onLiftChange, 20);
        }
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener("input", recompute);
      qtyInput.addEventListener("change", recompute);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccessoryBlock);
  } else {
    initAccessoryBlock();
  }
})();